import styled from 'styled-components'

const Info = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export default Info
